import { ResponseState } from '@anm/api';
import useNotifications from '@anm/hooks/useNotifications';

import NOTIFICATION_MESSAGES from '../notificationMessages';

const useLandingsNotifications = (entity: ResponseState) => {
  const { notifications } = useNotifications({
    ...entity,
    ...NOTIFICATION_MESSAGES
  });

  return notifications;
};

export default useLandingsNotifications;
